(function () {
  'use strict';

  if (window.KuKirinMobilityUiFixesLoaded) return;
  window.KuKirinMobilityUiFixesLoaded = true;

  var MENU_TOGGLE = '[data-km-menu-toggle]';
  var OPEN_CLASS = 'is-action__hover';
  var PROXY_FORM = 'form[data-km-product-cta-proxy]';
  var MAIN_FORM = 'form[data-type="add-to-cart-form"]';
  var MAIN_ATC = '[data-atc-form], button[type="submit"][name="add"]';

  function menuItem(link) {
    return link ? link.closest('.t4s-menu-item.has--children') : null;
  }

  function closeMenus(except) {
    document.querySelectorAll(MENU_TOGGLE).forEach(function (link) {
      var item = menuItem(link);
      if (!item || item === except) return;
      item.classList.remove(OPEN_CLASS);
      link.setAttribute('aria-expanded', 'false');
    });
  }

  function handleMenuClick(event) {
    if (window.innerWidth <= 1024) return;

    var link = event.target.closest ? event.target.closest(MENU_TOGGLE) : null;
    if (!link) {
      if (!event.target.closest || !event.target.closest('.t4s-menu-item')) closeMenus();
      return;
    }

    /* This top-level menu item intentionally has no destination URL. Stop it
       before Kalles/instant-page can turn the blank link into a trip home. */
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    var item = menuItem(link);
    if (!item) return;

    var willOpen = !item.classList.contains(OPEN_CLASS);
    closeMenus(item);

    if (willOpen) {
      if (window.jQuery_T4NT) window.jQuery_T4NT(item).trigger('mouseenter');
      item.classList.add(OPEN_CLASS);
    } else {
      item.classList.remove(OPEN_CLASS);
    }

    link.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function getMainForm() {
    return document.querySelector(MAIN_FORM);
  }

  function getMainAtc() {
    var form = getMainForm();
    return form ? form.querySelector(MAIN_ATC) : null;
  }

  function mainAtcUnavailable() {
    var atc = getMainAtc();
    return !atc || atc.disabled || atc.getAttribute('aria-disabled') === 'true';
  }

  function syncProxyButtons() {
    var unavailable = mainAtcUnavailable();
    document.querySelectorAll(PROXY_FORM + ' button[type="submit"]').forEach(function (button) {
      button.disabled = unavailable;
      button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
    });
  }

  function proxySubmit(event) {
    var form = event.target && event.target.closest ? event.target.closest(PROXY_FORM) : null;
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    var mainForm = getMainForm();
    var atc = getMainAtc();
    if (!mainForm || !atc || mainAtcUnavailable()) {
      syncProxyButtons();
      return;
    }

    if (typeof mainForm.reportValidity === 'function' && !mainForm.reportValidity()) return;

    /* Use the live product form so current variant, quantity and line-item
       properties are preserved instead of the legacy hard-coded variant. */
    atc.click();
  }

  function observeMainAtc() {
    var atc = getMainAtc();
    if (!atc || atc.dataset.kmProxyObserved === 'true') {
      syncProxyButtons();
      return;
    }

    atc.dataset.kmProxyObserved = 'true';
    new MutationObserver(syncProxyButtons).observe(atc, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
    syncProxyButtons();
  }

  /* Capture phase is deliberate: blank top-level menu items must be stopped
     before Kalles/instant-page navigation handlers. */
  document.addEventListener('click', handleMenuClick, true);
  document.addEventListener('submit', proxySubmit, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenus();
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest(MAIN_FORM)) {
      window.setTimeout(syncProxyButtons, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', observeMainAtc);
  document.addEventListener('shopify:section:load', observeMainAtc);

  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:changed.kmProductCta', function () {
      window.setTimeout(syncProxyButtons, 0);
    });
  }

  observeMainAtc();
})();
